import Typography from "@portal/components/atoms/v2/typography";

interface Props {
  suitabilityReport: string[];
  header: string;
}

/**
 * Component to display the suitability report after the savings robot is carried out.
 * @param interface
 * @returns the array of text from the report, spread out with spacing.
 */
export const SuitabilityReport = ({ suitabilityReport, header }: Props) => {
  const spacing = 10;

  return (
    <div className="flex flex-col bg-white border rounded-lg mt-2 px-3 pt-2 pb-4">
      <Typography variant={"Lead"}>{header}</Typography>
      <div className="flex flex-col">
        <div className="flex" style={{ marginBottom: `${spacing}px` }}>
          <Typography variant={"Body"}>{`${suitabilityReport[0]}  ${suitabilityReport[1]}`}</Typography>
        </div>
        <div className="flex" style={{ marginBottom: `${spacing}px` }}>
          <Typography variant={"Body"}>{`${suitabilityReport[2]}  ${suitabilityReport[3]}`}</Typography>
        </div>
        <div className="flex" style={{ marginBottom: `${spacing}px` }}>
          <Typography variant={"Body"}>{`${suitabilityReport[4]}`}</Typography>
        </div>
        <div>
          <Typography variant={"Body"}>{`${suitabilityReport[5]}`}</Typography>
        </div>
      </div>
    </div>
  );
};
